import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button
} from '@chakra-ui/react'
import moment from 'moment';
import 'moment/locale/ru';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function EndDateModalEdit({ endDate, setEndDate, handleDate, setDndDateConfirm, allitem, endDateConfirm }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const getDarkModoe = useSelector(darkModes => darkModes);
    const getmyinfo = useSelector((allWorkers) => allWorkers);
    // const convertDate = () => {
    //     return moment(endDate).format('D MMMM, HH:mm');
    // }
    useEffect(() => {
        console.log("endDate:", endDate); // Добавьте это для отладки
    
        if (endDate) {
            const date = new Date(endDate);
            const formattedDate = date.toISOString(); // UTC-формат
            console.log("Отправка на сервер в UTC:", formattedDate);
            setDndDateConfirm(formattedDate);
        } else {
            console.error("endDate имеет недопустимое значение:", endDate);
        }
    }, [endDate]);
    

    const convertEndDate = (dateString) => {
        // Преобразуем строку в объект Date
        const date = new Date(dateString);

        // Получаем компоненты даты и времени
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Собираем строку в нужном формате
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };


    function convertDateText(endDate) {

        return moment(endDate).locale('ru').format('D MMMM, HH:mm');
        // Извлекаем дату и время
        const datePart = endDate.slice(0, 10); // "2024-08-10"
        const timePart = endDate.slice(11, 16); // "19:42"

        // Разделяем на компоненты
        const [year, month, day] = datePart.split('-');

        // Массив названий месяцев
        const months = [
            "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
            "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
        ];

        // Преобразуем номер месяца в название
        const monthName = months[parseInt(month, 10) - 1];

        // Собираем строку в формате "DD Месяц YYYY, HH:MM"
        const formattedDateTime = `${day} ${monthName}, ${timePart}`;

        return formattedDateTime

    }

    const changeDate = (value) => {
        const date = new Date(value);
        const formattedDate = date.toISOString(); // UTC-формат
        console.log("Отправка на сервер в UTC:", formattedDate);
        setEndDate(formattedDate);        

    };



    // Преобразуем UTC в локальное время для отображения
    const convertToLocalTime = (utcDate) => {
        const date = new Date(utcDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`; // "YYYY-MM-DDTHH:mm"
    };

    // Форматируем данные для input

    //   const formattedEndDate = convertEndDate(endDateConfirm);
    const formattedEndDate = convertToLocalTime(endDate);

 
    return (
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "startDateModalDarkCont" : "startDateModalLightCont"}>

            <div onClick={onOpen}>
                <input type="text" name="" id="" value={convertDateText(formattedEndDate)} />
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 5H15V4.50468C15 4.21404 15.226 4 15.5047 4H16.4953C16.786 4 17 4.22595 17 4.50468V5H18.7568C19.3028 5 19.75 5.44725 19.75 5.99896V7.00104C19.75 7.55734 19.3053 8 18.7568 8H5.24317C4.69717 8 4.25 7.55275 4.25 7.00104V5.99896C4.25 5.44266 4.69466 5 5.24317 5H7V4.50468C7 4.21404 7.22596 4 7.50468 4H8.49532C8.78596 4 9 4.22595 9 4.50468V5ZM5.50468 9H6.49532C6.78596 9 7 9.22596 7 9.50468V10.4953C7 10.786 6.77404 11 6.49532 11H5.50468C5.21404 11 5 10.774 5 10.4953V9.50468C5 9.21404 5.22595 9 5.50468 9ZM8.50468 9H9.49532C9.78596 9 10 9.22596 10 9.50468V10.4953C10 10.786 9.77404 11 9.49532 11H8.50468C8.21404 11 8 10.774 8 10.4953V9.50468C8 9.21404 8.22596 9 8.50468 9ZM11.5047 9H12.4953C12.786 9 13 9.22596 13 9.50468V10.4953C13 10.786 12.774 11 12.4953 11H11.5047C11.214 11 11 10.774 11 10.4953V9.50468C11 9.21404 11.226 9 11.5047 9ZM5.50468 12H6.49532C6.78596 12 7 12.226 7 12.5047V13.4953C7 13.786 6.77404 14 6.49532 14H5.50468C5.21404 14 5 13.774 5 13.4953V12.5047C5 12.214 5.22595 12 5.50468 12ZM8.50468 12H9.49532C9.78596 12 10 12.226 10 12.5047V13.4953C10 13.786 9.77404 14 9.49532 14H8.50468C8.21404 14 8 13.774 8 13.4953V12.5047C8 12.214 8.22596 12 8.50468 12ZM11.5047 12H12.4953C12.786 12 13 12.226 13 12.5047V13.4953C13 13.786 12.774 14 12.4953 14H11.5047C11.214 14 11 13.774 11 13.4953V12.5047C11 12.214 11.226 12 11.5047 12ZM5.50468 15H6.49532C6.78596 15 7 15.226 7 15.5047V16.4953C7 16.786 6.77404 17 6.49532 17H5.50468C5.21404 17 5 16.774 5 16.4953V15.5047C5 15.214 5.22595 15 5.50468 15ZM8.50468 15H9.49532C9.78596 15 10 15.226 10 15.5047V16.4953C10 16.786 9.77404 17 9.49532 17H8.50468C8.21404 17 8 16.774 8 16.4953V15.5047C8 15.214 8.22596 15 8.50468 15ZM11.5047 15H12.4953C12.786 15 13 15.226 13 15.5047V16.4953C13 16.786 12.774 17 12.4953 17H11.5047C11.214 17 11 16.774 11 16.4953V15.5047C11 15.214 11.226 15 11.5047 15ZM14.5047 9H15.4953C15.786 9 16 9.22596 16 9.50468V10.4953C16 10.786 15.774 11 15.4953 11H14.5047C14.214 11 14 10.774 14 10.4953V9.50468C14 9.21404 14.226 9 14.5047 9ZM14.5047 12H15.4953C15.786 12 16 12.226 16 12.5047V13.4953C16 13.786 15.774 14 15.4953 14H14.5047C14.214 14 14 13.774 14 13.4953V12.5047C14 12.214 14.226 12 14.5047 12ZM14.5047 15H15.4953C15.786 15 16 15.226 16 15.5047V16.4953C16 16.786 15.774 17 15.4953 17H14.5047C14.214 17 14 16.774 14 16.4953V15.5047C14 15.214 14.226 15 14.5047 15ZM17.5047 15H18.4953C18.786 15 19 15.226 19 15.5047V16.4953C19 16.786 18.774 17 18.4953 17H17.5047C17.214 17 17 16.774 17 16.4953V15.5047C17 15.214 17.226 15 17.5047 15ZM5.50468 18H6.49532C6.78596 18 7 18.226 7 18.5047V19.4953C7 19.786 6.77404 20 6.49532 20H5.50468C5.21404 20 5 19.774 5 19.4953V18.5047C5 18.214 5.22595 18 5.50468 18ZM8.50468 18H9.49532C9.78596 18 10 18.226 10 18.5047V19.4953C10 19.786 9.77404 20 9.49532 20H8.50468C8.21404 20 8 19.774 8 19.4953V18.5047C8 18.214 8.22596 18 8.50468 18ZM11.5047 18H12.4953C12.786 18 13 18.226 13 18.5047V19.4953C13 19.786 12.774 20 12.4953 20H11.5047C11.214 20 11 19.774 11 19.4953V18.5047C11 18.214 11.226 18 11.5047 18ZM14.5047 18H15.4953C15.786 18 16 18.226 16 18.5047V19.4953C16 19.786 15.774 20 15.4953 20H14.5047C14.214 20 14 19.774 14 19.4953V18.5047C14 18.214 14.226 18 14.5047 18ZM17.5047 18H18.4953C18.786 18 19 18.226 19 18.5047V19.4953C19 19.786 18.774 20 18.4953 20H17.5047C17.214 20 17 19.774 17 19.4953V18.5047C17 18.214 17.226 18 17.5047 18ZM17.5047 12H18.4953C18.786 12 19 12.226 19 12.5047V13.4953C19 13.786 18.774 14 18.4953 14H17.5047C17.214 14 17 13.774 17 13.4953V12.5047C17 12.214 17.226 12 17.5047 12ZM17.5047 9H18.4953C18.786 9 19 9.22596 19 9.50468V10.4953C19 10.786 18.774 11 18.4953 11H17.5047C17.214 11 17 10.774 17 10.4953V9.50468C17 9.21404 17.226 9 17.5047 9Z" fill="#353535" />
                    </svg>
                </div>
            </div>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent className={getDarkModoe.ToggleDarkModeReducer.chekced ? "StartDateAndEndDateContentModalDark" : "StartDateAndEndDateContentModalLight"}>
                    <ModalHeader>Дата окончания:</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {
                            allitem?.creatorTasks !== getmyinfo.getMayInfoReducer.myinfo._id ?
                                <input type="datetime-local" value={formattedEndDate} onChange={(e) => setDndDateConfirm(e.target.value)} />
                                :
                                <input type="datetime-local" value={formattedEndDate} onChange={(e) => changeDate(e.target.value)} />
                        }

                    </ModalBody>

                    <ModalFooter>
                        {
                            allitem?.creatorTasks !== getmyinfo.getMayInfoReducer.myinfo._id ?
                                <Button colorScheme='blue' mr={3} onClick={() => [handleDate(), onClose()]}>
                                    Перенести
                                </Button>
                                :
                                ""
                        }

                        <Button mr={3} onClick={onClose}>
                            Закрыть
                        </Button>

                    </ModalFooter>
                </ModalContent>
            </Modal>
        </div>
    )

}